import React__default from 'react';
import { List, Image } from '@grandvisionhq/common';
import { Heading, Hr } from '@grandvisionhq/elements';

const Measure = ({ measureDescription , measureDescriptionImage , measureImage , measureSteps , measureTitle ,  })=>{
    if (!measureTitle || !measureSteps || !measureImage || !measureDescriptionImage) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "measure"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        className: "measure__title"
    }, measureTitle), /*#__PURE__*/ React__default.createElement("div", {
        className: "measure__container"
    }, /*#__PURE__*/ React__default.createElement(List, {
        items: measureSteps,
        numerical: true
    }), /*#__PURE__*/ React__default.createElement(Image, {
        alt: "frame measure",
        className: "measure__steps-image",
        url: measureImage.url
    })), /*#__PURE__*/ React__default.createElement(Hr, null), /*#__PURE__*/ React__default.createElement("div", {
        className: "measure__container"
    }, /*#__PURE__*/ React__default.createElement("div", null, measureDescription), /*#__PURE__*/ React__default.createElement(Image, {
        alt: "frame measure",
        className: "measure__description-image",
        url: measureDescriptionImage.url
    })));
};
var Measure$1 = Measure;

export { Measure$1 as default };
//# sourceMappingURL=Measure.js.map
